/* eslint-disable react/require-default-props */
import React from 'react';
import { Button } from './styles';

interface AiManagementOpenButtonProps {
  label: string;
  active?: boolean;
  onClick: () => void;
}

const AiManagementOpenButton: React.FC<AiManagementOpenButtonProps> = ({
  label,
  active = false,
  onClick,
}) => (
  <Button
    type="button"
    className={`btn ${
      active ? 'btn-success' : 'btn-open'
    } d-inline-flex align-items-center justify-content-center p-0`}
    onClick={onClick}
    aria-pressed={active}
    aria-label={label}
  >
    <i className="material-icons">chevron_right</i>
  </Button>
);

export default AiManagementOpenButton;
